<ng-container [ngSwitch]="toolType$ | async">
  <mg-st-behaviours *ngSwitchCase="'student'"></mg-st-behaviours>
</ng-container>
